/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMailMinus = createReactComponent("mail-minus", "IconMailMinus", [
  [
    "path",
    {
      d: "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M3 7l9 6l9 -6", key: "svg-2" }]
]);

export { IconMailMinus as default };
//# sourceMappingURL=IconMailMinus.js.map
